import type * as React from 'react';

import { PanelSet } from '@gitbook/spine-react';

import type { SitesCustomizationPanelProps } from '../types';
import { PanelAnnouncement } from './Announcement';
import { PanelFooter } from './Footer';
import { PanelHeader } from './Header';
import { PanelPage } from './Page';

export function TabLayout(props: SitesCustomizationPanelProps): React.ReactElement {
    return (
        <PanelSet>
            <PanelHeader {...props} />
            <PanelAnnouncement {...props} />
            <PanelPage {...props} />
            <PanelFooter {...props} />
        </PanelSet>
    );
}
